<template>
  <div id="repaymentSuccessful">
    <div class="headerStatus">
      <img src="@/assets/images/success.png" alt="" />
      <h3>还款成功</h3>
    </div>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">还款日期：</span>
        <span class="infoListRight">{{
          this.$store.state.commonForms.dateAmt || ''
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款本金：</span>
        <span class="infoListRight">¥{{
          this.$store.state.otherPages.amount || ''
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款利息：</span>
        <span class="infoListRight">¥{{
          this.otherPages.addOkCalculationObj.repay_inter_now || ''
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">剩余本金：</span>
        <span class="infoListRight">¥{{
          this.otherPages.addOkCalculationObj.rest_amt || ''
        }}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="goToNextPage"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Button from '@/components/Button.vue';

export default {
  name: 'repaymentSuccessful',
  data() {
    return {
      danger: 'danger',
      draw: '返回我的融资',
    };
  },
  components: {
    Button,
  },
  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
  },

  mounted() {
    console.log(this.otherPages.addOkCalculationObj, '=======');
  },
  methods: {
    goToNextPage() {
      this.$router.push('/supermarket/v2/myload');
    },
  },
};
</script>
<style scoped>
#repaymentSuccessful{
  background: #fff;
}

.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #7d828e;
  font-size: 14px;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
